module.exports = __webpack_public_path__ + "static/media/twitter.b4d01417.svg";